import Vue from 'vue';
import App from './App.vue';
import qs from 'qs';
// 注意优先级
import _ from 'lodash';
import router from './router';
import store from './store';
import './plugins/element.js';
import './assets/css/style.css';
import './assets/fonts/iconfont.css';
import global from './api/global.vue';
import Axios from './api/interceptors.js';
import Debounce from './utils/interval';
import { parseTime } from './utils/httpRequest';
// import print from './assets/js/print.js';

Vue.prototype._ = _;

Vue.config.productionTip = false;
// Vue.use(AxiosPlugin);
// Vue.use(print);
Vue.prototype.global = global;
Vue.prototype.$qs = qs;
Vue.prototype.$axios = Axios;
Vue.prototype.parseTime = parseTime;
// <!--当是isDebounce==1时表示是防抖函数，isDebounce==2是节流函数，isDebounce==3是立即执行版防抖函数，time是执行时间间隔,UI框架click事件失效时可用修饰符native-->
Vue.component('Debounce', Debounce);
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')


